import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, logout, user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isHome = location.pathname === "/";

  const menuItems = [
    { name: "home", path: "/" },
    { name: "about", path: "/about" },
    { name: "posts", path: "/posts" },
    { name: "boards", path: "/boards" },
    ...(isLoggedIn
      ? [
          { name: "tasks", path: "/tasks" },
          { name: "ansible", path: "/ansible" },
        ]
      : []),
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 h-16 ${isHome ? "text-white bg-transparent" : "text-black bg-white shadow"}`}>
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        {/* 로고 */}
        <Link to="/" className="text-xl font-bold tracking-wide">
          ICURFER
        </Link>

        {/* ✅ 메뉴 (lg 이상만 보임) */}
        <div className="hidden lg:flex space-x-6 font-semibold">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="hover:text-yellow-400 transition capitalize"
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* ✅ 우측 로그인/로그아웃 버튼 (lg 이상만 보임) */}
        <div className="hidden lg:flex space-x-2 items-center">
          {isLoggedIn ? (
            <>
              <Link to="/profile" className={`px-4 py-2 rounded-full shadow ${isHome ? "bg-white text-black" : "bg-gray-200 text-gray-800"}`}>
                내 정보 | 등급: {user?.grade && `(${user.grade})`}
              </Link>
              <button onClick={() => { logout(); navigate("/login"); }} className={`px-4 py-2 rounded-full ${isHome ? "bg-white text-black" : "bg-gray-200 text-gray-800"} hover:bg-gray-300`}>
                로그아웃
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className={`px-4 py-2 rounded-full ${isHome ? "bg-gray-200 text-gray-700 hover:bg-gray-300" : "bg-blue-600 text-white"}`}>
                로그인
              </Link>
              <Link to="/register" className={`px-4 py-2 rounded-full ${isHome ? "bg-gray-700 text-white hover:bg-gray-300" : "bg-gray-200 text-gray-800"}`}>
                회원가입
              </Link>
            </>
          )}
        </div>

        {/* ✅ 모바일 햄버거 아이콘 (lg 미만일 때 보임) */}
        <div className="lg:hidden">
          <button onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* ✅ 모바일 메뉴 드롭다운 */}
      {mobileOpen && (
        <div className="lg:hidden bg-white shadow px-4 pt-4 pb-6 space-y-4">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="block text-gray-800 font-medium"
              onClick={() => setMobileOpen(false)}
            >
              {item.name}
            </Link>
          ))}
          <div className="flex flex-col space-y-2">
            {isLoggedIn ? (
              <>
                <Link to="/profile" onClick={() => setMobileOpen(false)} className="bg-gray-100 px-4 py-2 rounded">
                  내 정보 | 등급: {user?.grade && `(${user.grade})`}
                </Link>
                <button
                  onClick={() => {
                    logout();
                    navigate("/login");
                    setMobileOpen(false);
                  }}
                  className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
                >
                  로그아웃
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setMobileOpen(false)} className="bg-blue-600 text-white px-4 py-2 rounded">
                  로그인
                </Link>
                <Link to="/register" onClick={() => setMobileOpen(false)} className="bg-gray-100 text-gray-800 px-4 py-2 rounded">
                  회원가입
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;